<template>
  <div class="search-component" :class="classes">
    <i class="ph ph-magnifying-glass fs-16" />
    <input
      class="form-control"
      v-model="search"
      :placeholder="placeholder"
      :disabled="disabled"
    />
    <span v-if="loading && !disabled" class="loading-spinner">
      <b-spinner style="width: 12px; height: 12px" />
    </span>
    <i
      v-if="clearable && search.length && !loading"
      class="ph-fill ph-x-circle btn-clear fs-16"
      @click="search = ''"
    />
  </div>
</template>

<script>
let timeout;

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Pesquisar"
    },
    clearable: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    full: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: "outline",
      validator: value => ["outline", "gray"].includes(value)
    }
  },
  computed: {
    classes() {
      return {
        disabled: this.disabled,
        outline: this.variant === "outline",
        gray: this.variant === "gray",
        loading: this.loading,
        full: this.full
      };
    }
  },
  data() {
    return {
      search: this.value
    };
  },
  watch: {
    search(newValue) {
      if (newValue != this.value) {
        this.$emit("input", newValue);

        clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.$emit("search", newValue);
        }, 500);
      }
    },
    value(newValue) {
      this.search = newValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.search-component {
  display: flex;
  align-items: center;
  width: 160px;
  border: 0.5px solid transparent;
  border-radius: 8px;
  padding: 4px 8px;
  min-height: 0;
  transition: all 0.2s ease-in-out;

  &.full {
    width: 100%;
  }

  @media (max-width: 991px) {
    width: 100%;
  }

  .loading-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .form-control {
    min-height: 0;
    height: auto;
    font-size: 14px;
    padding: 0px 8px;
    background: transparent;
    color: var(--dark);
    width: 100%;
    border: none;

    &::placeholder {
      color: var(--dark-10);
      font-size: 14px !important;
      transition: color 0.2s ease-in-out;
    }
  }

  .ph-magnifying-glass {
    transition: color 0.2s ease-in-out;
  }

  .btn-clear {
    cursor: pointer;
    color: var(--dark-10);
  }

  &:focus-within {
    border: 0.5px solid var(--dark-40) !important;
    box-shadow: 0px 0px 0px 4px rgba(0, 0, 0, 0.05);
    background: var(--bg-5) !important;

    .form-control {
      box-shadow: none !important;
    }

    .ph-magnifying-glass {
      color: var(--dark) !important;
    }
  }

  &.gray {
    background: var(--dark-4);

    .ph-magnifying-glass {
      color: var(--dark-20);
    }

    ::placeholder {
      color: var(--dark-20);
    }

    &:not(.disabled):hover {
      background: var(--dark-10);

      ::placeholder {
        color: var(--dark-20);
      }

      .ph-magnifying-glass {
        color: var(--dark-40);
      }
    }
  }

  &.outline {
    background: var(--bg-5);
    border-color: var(--dark-10);

    .form-control {
      &::placeholder {
        color: var(--dark-40);
      }
    }

    .ph-magnifying-glass {
      color: var(--dark-20);
    }

    &:not(.disabled):hover {
      border-color: var(--dark-40);

      .ph-magnifying-glass {
        color: var(--dark-40);
      }
    }
  }

  &.loading {
    border-color: var(--dark-10) !important;
    box-shadow: none;
    .ph-magnifying-glass {
      color: var(--dark-20) !important;
    }
  }

  &.disabled {
    cursor: not-allowed;
    background: var(--dark-4) !important;
    border: none;

    .form-control {
      cursor: not-allowed;
      &::placeholder {
        color: var(--dark-20);
      }
    }

    .ph-magnifying-glass {
      color: var(--dark-20);
    }
  }
}
</style>
